import {backboneViewProperties} from "../../decorators/backbone-properties";
import Marionette from "../../shared/marionette-mustache";
import {UserHistoryItemModel} from "../../user-history/models/user-history-item";
import {autoinject, Container} from "aurelia-dependency-injection";
import {AuthorizationModel} from "../../authentication/models/authorization-model";
import {AppEvents} from "../../app-events";
import {AppSettings} from "../../app-settings";
import {IRequestOptions} from "../../search/interfaces/request-options";

import "timeago";
import { ContainerHelper } from "../../shared/helpers/container-helper";

const docTemplate = require<string>("../../user-history/views/user-history-item-document.html");
const searchTemplate = require<string>("../../user-history/views/user-history-item-search.html");
const fullTextTemplate = require<string>("../../user-history/views/user-history-item-full-text.html");

@backboneViewProperties({
    tagName: "li"
})
@autoinject
export class UserHistoryItemView extends Marionette.ItemView<UserHistoryItemModel> {
    private template: string;

    constructor(options?) {
        super(options);
        this.setTemplate();
    }

    public events() {
        const events: Backbone.EventsHash = {};
        events["click .history-item-link"] = (e) => this.itemLinkClicked(e);
        return events;
    }

    public onShow() {
        this.$(".timestamp").timeago();
    }

    private itemLinkClicked(e: JQueryEventObject) {
        e.preventDefault();
        e.stopPropagation();

        const appEvents = ContainerHelper.Events;
        const $target = $(e.currentTarget);
        const type = $target.attr("data-type");
        appEvents.trigger(AppEvents.AppInsightsHistory, {Type: type, Title: $.trim($target.text()).toLowerCase()});

        switch (type) {
            case "document":
                this.documentItemLinkClicked(e);
                break;
            case "search":
                this.searchItemLinkClicked(e);
                break;
            case "link":
                this.fulltextLinkItemClicked(e);
                break;
        }
    }

    private documentItemLinkClicked(e: JQueryEventObject) {

        const $target = $(e.currentTarget);
        const id = $target.attr("data-id");
        const title =  $target.attr("data-url-title");

        // this docType/renderType was taken from a document request's type directly
        // so is suitable to just be used in the url
        let docType = $target.attr("data-render-type") || "document";
        let sectionNumber = "";
        if (docType === "statute_section") {
            // need to undo some of the magic that happens in the router to get the right url
            docType = "statute";
            sectionNumber = "/0";
        }

        const url = `${docType}/${title}${sectionNumber}/overview/${id}`;
        Backbone.history.navigate(url, true);
    }

    private setTemplate() {
        let template;
        switch (this.model.Type) {
            case 1:
                template = docTemplate;
                break;
            case 2:
                template = searchTemplate;
                break;
            case 3:
                template = fullTextTemplate;
                break;
        }
        this.template = template;
    }

    private searchItemLinkClicked(e: JQueryEventObject) {

        const $target = $(e.currentTarget);

        const query = $.trim($target.text());

        const options: IRequestOptions = {
            page: 1,
            query: query,
            materialTypes: [],
            order: "Relevance",
            includedCategoryFilters: [],
            includedProductFilters: null
        };
        const events = ContainerHelper.Events;
        events.trigger(AppEvents.ResetSearch);
        events.trigger(AppEvents.SearchRequest, options);
    }

    private fulltextLinkItemClicked(e: JQueryEventObject) {
        const $target = $(e.currentTarget);

        // the link will navigate by itself, but let's log that they visited it again
        try {
                ($ as any).ajax({
                    url: AppSettings.ApiUrlPrefix + "logging/Log",
                    beforeSend: AuthorizationModel.attachAuthorizationHeader,
                    method: "POST",
                    cache: false,
                    data: {
                        name: this.model.get("Value").Name,
                        url: $target.attr("href"),
                        siteId: this.model.get("Value").SiteId
                    }
                });

        } catch (e) {
           dev.log("Error logging multilink click: " + e);
        }
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/user-history/views/user-history-item.ts